import React from 'react'
import { Button, Col, Row, Table } from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalRepeatProfile = (props) => {

    const {
        modalRepeatProfile,
        validationsRepeat,
        modalTitle,
        toggleRepeatProfile
    } = props;


    const {
        repeat_profiles,
        name_profile
    } = validationsRepeat;

    return (
        <Dialog
            visible={modalRepeatProfile}
            headerStyle={{
                backgroundColor: '#0f172a',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0f172a', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            onHide={toggleRepeatProfile}
            maskClassName="custom-discount-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-flask f-20"></i>
                        </div>
                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }

            className={`Global-dialog Global-dialog Global-blue Global-small-2 `}
            footer={
                <Button
                    color="danger"
                    type="button"
                    onClick={toggleRepeatProfile}
                >
                    Cerrar
                </Button>
            }

        >
            <Col sm="12" className="profile-repeat-container pl-0 pr-0">

                <Row>
                    <Col sm="12">
                        <div className="profile-repeat-header">
                            <i className="pi pi-info-circle"></i>
                            <span>
                                El perfil <b>{name_profile}</b> se compone de los elementos de la derecha y la izquierda.
                            </span>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col sm="12">
                        <div className="profile-repeat-table-wrapper">

                            <Table className="profile-repeat-table">
                                <tbody>
                                    {
                                        repeat_profiles.length > 0 && repeat_profiles.map((x, key) => (
                                            <React.Fragment key={"RepeatProfile" + key}>

                                                <tr className="table-main-header">
                                                    <th>{x.name_profile}</th>
                                                    <th>{name_profile}</th>
                                                </tr>

                                                <tr className="table-sub-header">
                                                    <td className="match">Coincidencias</td>
                                                    <td className="no-match">Sin coincidencias</td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        <ul>
                                                            {
                                                                x.listExamsRepeat.map((e, keyExam) => (
                                                                    <li key={'subexam' + keyExam}>{e.name}</li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </td>

                                                    <td>
                                                        <ul>
                                                            {
                                                                x.listExamsNotRepeat.map((er, keyNot) => (
                                                                    <li key={'notExist' + keyNot}>{er.name}</li>
                                                                ))
                                                            }
                                                        </ul>
                                                    </td>
                                                </tr>

                                            </React.Fragment>
                                        ))
                                    }
                                </tbody>
                            </Table>

                        </div>
                    </Col>
                </Row>
            </Col>
        </Dialog>
    )
}
